module.exports = __webpack_public_path__ + "img/prosciutto.a58707d1.png";